module.exports = __webpack_public_path__ + "static/media/Certificate.9c56af1d.svg";